<template>
  <header class="menu-header">
    <nav class="skip-links">
      <ul>
        <li class="to-content"><a href="#conteudo">conteúdo</a></li>
        <li class="to-menu"><a href="#menu">menu</a></li>
      </ul>
    </nav>
    <nav class="main-menu">
      <div class="menu-container">
        <button class="mobile-button">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="brand-wrap">
          <a href="/" class="logo-ciro">Virar o jogo com Ciro</a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Menu',
};
</script>

